export default "__VITE_ASSET__CQ44CcgL__"